/**
 * 頁の頭の帯。本体の yumesaku.tech の同じ種類の頁 (apps/client の PublicArtBand) と同じ絵を、同じ名前のまま置く。
 * 中身のハッシュが名前に入っているので、描き直したら別の名前になる (public/assets は 1 年 immutable)。
 * 特定商取引法の帯は本体にも無いので、契約の書類の絵の terms を使う
 */
const PAGE_BANDS = {
  privacy: { wide: "/assets/art/privacy-1440-ff02bf8412.webp", sp: "/assets/art/privacy-sp-716-1010c2f7dd.webp" },
  terms: { wide: "/assets/art/terms-1440-62c6923760.webp", sp: "/assets/art/terms-sp-716-9c608eff61.webp" },
  news: { wide: "/assets/art/news-1440-5cf59a4e68.webp", sp: "/assets/art/news-sp-716-80134e8e2f.webp" },
  contact: { wide: "/assets/art/contact-1440-2a2e269541.webp", sp: "/assets/art/contact-sp-716-2af7cca8eb.webp" },
} as const;

export type PageBandName = keyof typeof PAGE_BANDS;

/**
 * 各ページ共通のヒーローバナー
 * 白背景 + 英語グラデーションタイトル + 日本語タイトル
 * band を渡すと、題のすぐ下に字の無い絵の帯を本文の幅で置く (HP の「手に入る、15のもの。」の頭の帯と同じ組み)
 */
export function PageHero({
  title,
  englishTitle,
  subtitle,
  band,
  bandClassName = "max-w-3xl mx-auto px-4",
}: {
  title: string;
  /** 英語タイトル（グラデーション表示） */
  englishTitle?: string;
  subtitle?: string;
  /** 題の下に置く帯の名前 */
  band?: PageBandName;
  /** 帯の箱の幅と左右の余白。下のパンくずの箱と同じ値を渡して、左右の端をそろえる */
  bandClassName?: string;
}) {
  return (
    <>
    <section
      className="page-hero relative overflow-hidden bg-white"
      style={{ minHeight: "200px" }}
    >
      <div
        className="relative z-10 flex flex-col items-center justify-center px-4 py-14 md:py-20"
        style={{ minHeight: "200px" }}
      >
        {englishTitle && (
          <p
            className="text-center font-bold tracking-[0.25em] uppercase text-3xl md:text-5xl mb-3 bg-clip-text text-transparent"
            style={{
              fontFamily: "'Zen Kaku Gothic Antique', sans-serif",
              backgroundImage: "linear-gradient(90deg, var(--color-shegate-accent) 0%, #b22629 100%)",
            }}
          >
            {englishTitle}
          </p>
        )}
        <h1
          className="text-[#252525] text-center font-bold tracking-[0.12em] text-lg md:text-xl"
          style={{ fontFamily: "YakuHanJP, 'Zen Kaku Gothic Antique', sans-serif" }}
        >
          {title}
        </h1>
        {subtitle && (
          <p
            className="text-[#899AA4] text-sm md:text-base tracking-widest mt-3"
            style={{ fontFamily: "YakuHanJP, 'Zen Kaku Gothic Antique', sans-serif" }}
          >
            {subtitle}
          </p>
        )}
      </div>
    </section>
    {band && (
      <div className={`${bandClassName} pt-8 md:pt-10`}>
        {/* 頁の頭の 1 枚 (LCP) なので先に読む。飾りなので読み上げない。picture に属性を付けると women-astro の postbuild がスマホの版を先読みできないので、箱は外の div が持つ */}
        <picture>
          <source media="(max-width: 767px)" srcSet={PAGE_BANDS[band].sp} width={716} height={218} />
          <img
            src={PAGE_BANDS[band].wide}
            alt=""
            aria-hidden="true"
            width={1440}
            height={280}
            loading="eager"
            fetchPriority="high"
            decoding="async"
            className="block h-auto w-full rounded-[2px]"
          />
        </picture>
      </div>
    )}
    </>
  );
}
